import {
  IAppState,
  filters,
  CALENDAT_VIEW,
  SCHEDULE_ACTION_TYPES,
  HEADER_VIEW,
  APPROVAL_LIST_TYPE,
  filtersIntervalApproval, filtersExternalApproval
} from './types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getSocialContentRestrictionsThunk,
  getSocialMediaRestrictionsThunk,
  getTimezonesThunk
} from './thunks'

const initialState: IAppState = {
  initial: null,
  calendarView: CALENDAT_VIEW.MONTH_VIEW,
  headerView: HEADER_VIEW.CALENDAR,
  filters: filters,
  isShowPopup: true,
  isShowLabels: true,
  timezones: [],
  inProgress: true,
  isOpenAddProject: false,
  isOpenEditProfile: false,
  isOpenNotificationSetting: false,
  isOpenHashtagSetting: false,
  isOpenPostType: false,
  isOpenAddPost: false,
  isInviteModalOpen: false,
  successModal: {
    isOpen: false,
    message: ''
  },
  scheduleModal: {
    isOpen: false,
    actionType: null
  },
  approvalListType:APPROVAL_LIST_TYPE.PENDING,
  filtersIntervalApproval: filtersIntervalApproval,
  filtersExternalApproval: filtersExternalApproval,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    // Calendar
    changeCalendarViewAction: (state, action: PayloadAction<CALENDAT_VIEW>) => {
      state.calendarView = action.payload
    },
    setIsShowPopupAction: (state, action) => {
      state.isShowPopup = action.payload
    },
    setIsShowLabelsAction: (state) => {
      state.isShowLabels = !state.isShowLabels
      state.filters.label = state.filters.label.map((label: any) => ({
        ...label,
        checked: state.isShowLabels
      }))
    },

    setFiltersAction: (state, action) => {
      const { type, id } = action.payload
      state.filters[type] = state.filters[type].map((item: any) =>
        item.id !== id ? item : { ...item, checked: !item.checked }
      )
    },

    clearFiltersAction: (state) => {
      const { status, label, social_post_type, social_network } = state.filters

      const uncheckFilters = (filter: any[]) => filter.map((item) => ({ ...item, checked: false }))

      state.filters = {
        status: uncheckFilters(status),
        label: uncheckFilters(label),
        social_post_type: uncheckFilters(social_post_type),
        social_network: uncheckFilters(social_network)
      }
    },

    setLabelFiltersAction: (state, action) => {
      state.filters.label = action.payload
    },

    setIsShowApprovalLabelsAction: (state) => {
      state.isShowLabels = !state.isShowLabels

      state.filtersIntervalApproval.label = state.filtersIntervalApproval.label.map((label: any) => ({
        ...label,
        checked: state.isShowLabels
      }))

      state.filtersExternalApproval.label = state.filtersExternalApproval.label.map((label: any) => ({
        ...label,
        checked: state.isShowLabels
      }))
    },

    setFiltersApprovalAction: (state, action) => {
      const { type, id } = action.payload

      state.filtersIntervalApproval[type] = state.filtersIntervalApproval[type].map((item: any) =>
        item.id !== id ? item : { ...item, checked: !item.checked }
      )

      state.filtersExternalApproval[type] = state.filtersExternalApproval[type].map((item: any) =>
        item.id !== id ? item : { ...item, checked: !item.checked }
      )
    },

    clearFiltersApprovalAction: (state) => {
      const { status, label, social_post_type, social_network } = state.filtersIntervalApproval
      const uncheckFilters = (filter: any[]) => filter.map((item) => ({ ...item, checked: false }))

      state.filtersIntervalApproval = {
        status: uncheckFilters(status),
        label: uncheckFilters(label),
        social_post_type: uncheckFilters(social_post_type),
        social_network: uncheckFilters(social_network)
      }
    },

    clearFiltersExternalApprovalAction: (state) => {
      const { status, label, social_post_type, social_network } = state.filtersExternalApproval
      const uncheckFilters = (filter: any[]) => filter.map((item) => ({ ...item, checked: false }))

      state.filtersExternalApproval = {
        status: uncheckFilters(status),
        label: uncheckFilters(label),
        social_post_type: uncheckFilters(social_post_type),
        social_network: uncheckFilters(social_network)
      }
    },

    setLabelFiltersApprovalAction: (state, action) => {
      state.filtersIntervalApproval.label = action.payload
      state.filtersExternalApproval.label = action.payload
    },
    // Create post
    toggleChoosePostTypeAction: (state) => {
      state.isOpenPostType = !state.isOpenPostType
    },
    openSchedulePostModal: (state, action: PayloadAction<SCHEDULE_ACTION_TYPES>) => {
      state.scheduleModal = {
        isOpen: true,
        actionType: action.payload
      }
    },
    closeSchedulePostModal: (state) => {
      state.scheduleModal = {
        isOpen: false,
        actionType: null
      }
    },
    toggleIsAddingPostAction: (state) => {
      state.isOpenAddPost = !state.isOpenAddPost
    },
    // Settings
    toggleAddProjectModalAction: (state) => {
      state.isOpenAddProject = !state.isOpenAddProject
    },
    toggleEditProfileModalAction: (state) => {
      state.isOpenEditProfile = !state.isOpenEditProfile
    },
    toggleNotificationSettingModalAction: (state) => {
      state.isOpenNotificationSetting = !state.isOpenNotificationSetting
    },
    toggleHastagModalAction: (state) => {
      state.isOpenHashtagSetting = !state.isOpenHashtagSetting
    },
    // Invition
    toggleInviteModalAction: (state) => {
      state.isInviteModalOpen = !state.isInviteModalOpen
    },
    // Success modal
    showSuccessModalAction: (state, action) => {
      state.successModal = {
        isOpen: true,
        message: action.payload
      }
    },
    hideSuccessModalAction: (state) => {
      state.successModal = {
        isOpen: false,
        message: ''
      }
    },
    // Header
    setHeaderView: (state, action: PayloadAction<HEADER_VIEW>) => {
      state.headerView = action.payload
    },
    //Pending and Approved post view
    showApprovalListAction:(state,action:PayloadAction<any>) =>{
      state.approvalListType = action.payload
    }
  },
  extraReducers: (builder) => {
    // getTimezones
    builder.addCase(getTimezonesThunk.pending, (state, action) => {
      state.inProgress = true
    })
    builder.addCase(getTimezonesThunk.fulfilled, (state, action) => {
      state.inProgress = false
      state.timezones = action.payload.data
    })
    builder.addCase(getTimezonesThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    // get content restrictions
    builder.addCase(getSocialContentRestrictionsThunk.pending, (state, action) => {})
    builder.addCase(getSocialContentRestrictionsThunk.fulfilled, (state, action) => {
      // console.log('get_restr CONTENT', action.payload)
    })
    builder.addCase(getSocialContentRestrictionsThunk.rejected, (state, action) => {})
    // get media restrictions
    builder.addCase(getSocialMediaRestrictionsThunk.pending, (state, action) => {})
    builder.addCase(getSocialMediaRestrictionsThunk.fulfilled, (state, action) => {
      // console.log('get_restr MEDIA', action.payload)
    })
    builder.addCase(getSocialMediaRestrictionsThunk.rejected, (state, action) => {})
  }
})

export const {
  changeCalendarViewAction,
  setIsShowPopupAction,
  setFiltersAction,
  setHeaderView,
  clearFiltersAction,
  setLabelFiltersAction,
  setIsShowLabelsAction,
  toggleAddProjectModalAction,
  toggleEditProfileModalAction,
  toggleNotificationSettingModalAction,
  toggleHastagModalAction,
  toggleChoosePostTypeAction,
  toggleIsAddingPostAction,
  openSchedulePostModal,
  closeSchedulePostModal,
  showSuccessModalAction,
  hideSuccessModalAction,
  toggleInviteModalAction,
  showApprovalListAction,
  setIsShowApprovalLabelsAction,
  setFiltersApprovalAction,
  setLabelFiltersApprovalAction,
  clearFiltersApprovalAction,
  clearFiltersExternalApprovalAction
} = appSlice.actions
export default appSlice.reducer
